export function Footer() {
  return (
    <div>
      <p className="text-slate-400 text-xs">
        This website was coded using{" "}
        <a
          href="https://react.dev/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-slate-200 hover:text-slate-300"
        >
          React
        </a>{" "}
        and{" "}
        <a
          href="https://tailwindcss.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-slate-200 hover:text-slate-300"
        >
          TailwindCSS
        </a>{" "}
        on the{" "}
        <a
          href="https://bun.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-slate-200 hover:text-slate-300"
        >
          Bun
        </a>{" "}
        runtime. Design inspiration from{" "}
        <a
          href="https://brittanychiang.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-slate-200 hover:text-slate-300"
        >
          Brittany Chiang's portfolio
        </a>
        .
      </p>
    </div>
  );
}
